import { imageThumbnail } from '../constants/general';

// eslint-disable-next-line import/prefer-default-export
export const cartToText = cart => {
  const headerText = ':shopping_trolley: Hello! There is a new Styling Closet Request :shopping_trolley:\n' +
    'Please bring the following items \n' +
    '---\n';
    let text = '';
    cart.forEach(cartItem => {
      const productName = cartItem.product.data?.translations.find(
        translation => translation.language === 'en'
      )?.name || cartItem.product.name;
      const imageUrl = cartItem.product.images[0]?.image.replace('__IMAGE_PARAMS__', imageThumbnail);
      const currentProductText = `Image Link: ${imageUrl} \n` +
      `${cartItem.product.brand[0].name}: ${productName}\n` +
      `Category: ${cartItem.product.category[0].name}\n` +
      `Size: (name/number/sku/) ${cartItem.size.name} / ${cartItem.size.number} / ${cartItem.size.sku} \n` +
      `Qty: ${cartItem.qty}\n` +
      `Last Known Bin Location: ${cartItem.size.bin_locations[0].label}\n` +
      `Website: ${cartItem.product.weblink}\n\n`;
      text += currentProductText;
    })
    return headerText + text;
}
